import { FourOhFourPage } from '@/domains/four-oh-four/pages';

function FourOhFour(): JSX.Element {
  return <FourOhFourPage />;
}

export default FourOhFour;
